import { render, staticRenderFns } from "./ProfitabilityDocument.vue?vue&type=template&id=accbbe1a&"
import script from "./ProfitabilityDocument.vue?vue&type=script&lang=js&"
export * from "./ProfitabilityDocument.vue?vue&type=script&lang=js&"
import style0 from "./ProfitabilityDocument.vue?vue&type=style&index=0&id=accbbe1a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports